/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

export default {
      name_ar: 'name_ar',
    name_en: 'name_en',

};
